import isAddingAllowed from './isAddingAllowed';

export default (level, isAdmin, accountManagement, parent) =>
  isAddingAllowed(level, isAdmin, accountManagement, parent);
